export const default_additional_income = {
  income_type: "",
  description: "",
  yearly_amount: 0,
  monthly_amount: 0
};